<mat-card *ngIf="!loader">
    <mat-card-header class="justify-content-between align-items-center mb-3">
      <mat-card-title class="fs-5 mb-0">
        Latest blocked/un-blocked accounts
      </mat-card-title>
      <button mat-button color="primary" [routerLink]="['/activity','all-deactivated-accounts']" [skipLocationChange]="true">See more</button>
    </mat-card-header>
    <div class="rounded-3 bg-light">
      <sm-data-table [columnHeaders]="tableDisplayColumns" [dataSource]="accountList"
        [showMenuButton]="true" [menuDropdownTemplate]="menuTemplate">
      </sm-data-table>
    </div>
  </mat-card>
  
  <div *ngIf="loader" class="loader">
    <mat-spinner></mat-spinner>
  </div>
  <ng-template #menuTemplate let-value>
    <!-- <button mat-menu-item (click)="viewProfile(value)">
      <mat-icon class="material-icons-outlined">account_circle</mat-icon>
      <span>See profile</span>
    </button> -->
    <button mat-menu-item>
      <mat-icon class="material-icons-outlined">email</mat-icon>
      <span>Send message</span>
    </button>
    <button mat-menu-item *ngIf="value.block_unblock_status == 'Blocked'" (click)="unblock(value)">
      <mat-icon class="material-icons-outlined">email</mat-icon>
      <span>Un-block</span>
    </button>
  </ng-template>

